import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsCustomTimeScaleRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-custom-time-scale',
	path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId',
};
